// Step3.jsx
import React from 'react';
import DateSplit from '../widgets/date';
import FileUpload from '../../../../components/FileUpload/FileUploader';
import specialization from '../data/specialization.json';
import {
  validateDesiredDate,
  validateDocumentDate,
  validateUkrainianText,
  validateSpecializationRequired,
  validateFiles
} from '../validations/Step3';

const typeDocs = [
    { "name": "Довідка", "value": "1" },
    { "name": "Висновок", "value": "2" },
    { "name": "Направлення", "value": "3"}
];

const Step3 = ({ formData, onChange, errors }) => {


  return (
    <div className="form-section">
      <h2 className="form-section-title">Додаткові побажання</h2>

      <DateSplit 
        error={errors.desiredDate || errors.desiredDate} 
        date={formData.preferences.desiredDate} 
        setDate={(v)=>onChange('preferences.desiredDate', v)} 
        yearFrom={2017}  
        yearTo={2025} 
        label="Бажана дата вступу в садок" 
      />
      {errors.desiredDate && !errors.desiredDate && (
        <div className="invalid-feedback d-block">{errors.desiredDate}</div>
      )}
      
      <div className="form-row single">
        <div className="form-group">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="wish-age-menu"
              checked={formData.preferences.ageMenu}
              onChange={(e) => onChange('preferences.ageMenu', e.target.checked)}
            />
            <label className="form-check-label" htmlFor="wish-age-menu">
              Бажаю відвідувати групу, меншу за віком
            </label>
          </div>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="wish-specialization"
              checked={formData.preferences.specialization}
              onChange={(e) => {onChange('preferences.specialization', e.target.checked)}}
            />
            <label className="form-check-label" htmlFor="wish-specialization">
              Спеціалізація за станом здоров'я
            </label>
          </div>
        </div>
      </div>
      
      {formData.preferences.specialization && (
        <>
          <div className="form-row single">
            <div className="form-group">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="wish-inclusive"
                  checked={formData.preferences.inclusiveGroup}
                  onChange={(e) => onChange('preferences.inclusiveGroup', e.target.checked)}
                />
                <label className="form-check-label" htmlFor="wish-inclusive">
                  Бажаю відвідувати інклюзивну групу
                </label>
              </div>
              {errors.inclusiveGroup && <div className="invalid-feedback">{errors.inclusiveGroup}</div>}
              
                <div className="form-row single">
          <div className="form-group">
            {formData.preferences.inclusiveGroup  && (
              <div className="alert alert-info">
                <strong>Перелік видів захворювань, за якими передбачено створення місць інклюзивного типу:</strong>
                <p>
                  { ["58fdc4708e78266a9d926b65","58fdc47d8e78266a9d926b66","58fdc48f8e78266a9d926b67","58fdc49c8e78266a9d926b68","58fdc4a98e78266a9d926b69","58fdc4b48e78266a9d926b6a","593009177ed0bdb13cc331c3","58fdc4618e78266a9d926b64"].map((id, index)=><div>{index + 1}. {specialization.filter(r=>r._id == id)[0].name}.</div>)}
                </p>
                <p>
                  <strong>Чи можу я подати заявку з іншими типами захворювань?</strong><br />
                  Так, але в цьому випадку зніміть позначку щодо обрання групи з інклюзивним типом місць.
                </p>
              </div>)}
        
          </div>
        </div>
            </div>
          </div>
          
          <div className="form-row single">
            <div className="form-group">
              <label className="form-label">Вид захворювання *</label>
              <select
                className={`form-select ${errors.diseaseType || errors.diseaseType ? 'is-invalid' : ''}`}
                value={formData.preferences.diseaseType}
                onChange={(e) => onChange('preferences.diseaseType', e.target.value)}
              >
                <option value="">Приклад захворювання</option>
                {specialization.filter(r=>r.isActive).map(r=><option key={r._id} value={r._id}>{r.name}</option>)}
              </select>
              {errors.diseaseType && <div className="invalid-feedback">{errors.diseaseType}</div>}
              {errors.diseaseType && !errors.diseaseType && (
                <div className="invalid-feedback d-block">{errors.diseaseType}</div>
              )}
            </div>
          </div>
          
          {formData.preferences.diseaseType && (
            <>
              <div className="form-row two-cols">
                <div className="form-group">
                  <label className="form-label">Тип документа *</label>
                  <select
                    className={`form-select ${errors.diseaseDocumentType || errors.documentType ? 'is-invalid' : ''}`}
                    value={formData.preferences.diseaseDocument.type}
                    onChange={(e) => onChange('preferences.diseaseDocument.type', e.target.value)}
                  >
                    <option value="">Обраний документ</option>
                    {typeDocs.map(r=><option key={r.value} value={r.value}>{r.name}</option>)}
                  </select>
                  {errors.diseaseDocumentType && <div className="invalid-feedback">{errors.diseaseDocumentType}</div>}
                  {errors.documentType && !errors.diseaseDocumentType && (
                    <div className="invalid-feedback d-block">{errors.documentType}</div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Номер документа *</label>
                  <input
                    type="text"
                    className={`form-control ${errors.diseaseDocumentNumber || errors.documentNumber ? 'is-invalid' : ''}`}
                    placeholder="Ф-0919190"
                    value={formData.preferences.diseaseDocument.number}
                    onChange={(e) => onChange('preferences.diseaseDocument.number', e.target.value)}
                  />
                  {errors.diseaseDocumentNumber && <div className="invalid-feedback">{errors.diseaseDocumentNumber}</div>}
                  {errors.documentNumber && !errors.diseaseDocumentNumber && (
                    <div className="invalid-feedback d-block">{errors.documentNumber}</div>
                  )}
                </div>
              </div>
              
              <div className="form-row single">
                <div className="form-group">
                  <label className="form-label">Кому видано *</label>
                  <input
                    type="text"
                    className={`form-control ${errors.diseaseDocumentIssuedTo || errors.issuedTo ? 'is-invalid' : ''}`}
                    placeholder="Роман Романович Станіславченко"
                    value={formData.preferences.diseaseDocument.issuedTo}
                    onChange={(e) => onChange('preferences.diseaseDocument.issuedTo', e.target.value)}
                  />
                  {errors.diseaseDocumentIssuedTo && <div className="invalid-feedback">{errors.diseaseDocumentIssuedTo}</div>}
                  {errors.issuedTo && !errors.diseaseDocumentIssuedTo && (
                    <div className="invalid-feedback d-block">{errors.issuedTo}</div>
                  )}
                </div>
              </div>
              
              <DateSplit 
                error={errors.diseaseDocumentDate || errors.documentDate} 
                date={formData.preferences.diseaseDocument.issueDate} 
                setDate={(v)=>onChange('preferences.diseaseDocument.issueDate', v)} 
                yearFrom={2017}  
                yearTo={2025} 
                label="Дата видачі *" 
              />
              {errors.documentDate && !errors.diseaseDocumentDate && (
                <div className="invalid-feedback d-block">{errors.documentDate}</div>
              )}
              
              <FileUpload
                label='Завантажте фото чи скан-копію документа *'  
                value={formData.preferences.diseaseDocument.files} 
                onChange={(files)=>onChange('preferences.diseaseDocument.files', files)} 
                onBlur={(files)=>onChange('preferences.diseaseDocument.files', files)} 
                onFocus={(files)=>onChange('preferences.diseaseDocument.files', files)}
                multiple={true}
                errorVal={errors.diseaseDocumentFiles}
                maxSize={5 * 1024 * 1024}
                description='Один або кілька файлів у форматі PDF, JPG, PNG. Максимальний розмір файлу 5 МБ.'
              />
              {errors.files && !errors.diseaseDocumentFiles && (
                <div className="invalid-feedback d-block">{errors.files}</div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Step3;